import React, { useState } from 'react'
    import { Link, useLocation } from 'react-router-dom'
    import { Menu, X, Bot } from 'lucide-react'

    const Navbar = () => {
      const [isOpen, setIsOpen] = useState(false)
      const location = useLocation()

      const navigation = [
        { name: 'Home', href: '/' },
        { name: 'Services', href: '/services' },
        { name: 'Industries', href: '/industries' },
        { name: 'About', href: '/about' },
        { name: 'Contact', href: '/contact' },
      ]

      const isActive = (path) => location.pathname === path

      return (
        <nav className="bg-white shadow-lg sticky top-0 z-50" data-component-path="src/components/Navbar.jsx" data-component-line="1:4" data-component-id="src/components/Navbar.jsx:1:4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="src/components/Navbar.jsx" data-component-line="2:6" data-component-id="src/components/Navbar.jsx:2:6">
            <div className="flex justify-between h-16" data-component-path="src/components/Navbar.jsx" data-component-line="3:8" data-component-id="src/components/Navbar.jsx:3:8">
              <div className="flex items-center" data-component-path="src/components/Navbar.jsx" data-component-line="4:10" data-component-id="src/components/Navbar.jsx:4:10">
                <Link to="/" className="flex items-center space-x-2" data-component-path="src/components/Navbar.jsx" data-component-line="5:12" data-component-id="src/components/Navbar.jsx:5:12">
                  {/* <Bot className="h-8 w-8 text-blue-600" data-component-path="src/components/Navbar.jsx" data-component-line="6:14" data-component-id="src/components/Navbar.jsx:6:14" /> */}
                 <img src="/logo.png" alt="Tulians Logo" className="h-16 w-16" style={{ objectFit: 'contain' }}/>
                  <span className="text-xl font-bold gradient-text" data-component-path="src/components/Navbar.jsx" data-component-line="7:14" data-component-id="src/components/Navbar.jsx:7:14">Tulians Technology</span>
                </Link>
              </div>

              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center space-x-8" data-component-path="src/components/Navbar.jsx" data-component-line="11:10" data-component-id="src/components/Navbar.jsx:11:10">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                      isActive(item.href)
                        ? 'text-blue-600 bg-blue-50'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                    }`}
                    data-component-path="src/components/Navbar.jsx" data-component-line="12:12" data-component-id="src/components/Navbar.jsx:12:12"
                  >
                    {item.name}
                  </Link>
                ))}
                <Link to="/contact" className="btn-primary" data-component-path="src/components/Navbar.jsx" data-component-line="23:12" data-component-id="src/components/Navbar.jsx:23:12">
                  Get Started
                </Link>
              </div>

              {/* Mobile menu button */}
              <div className="md:hidden flex items-center" data-component-path="src/components/Navbar.jsx" data-component-line="28:10" data-component-id="src/components/Navbar.jsx:28:10">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="text-gray-700 hover:text-blue-600 focus:outline-none focus:text-blue-600"
                  data-component-path="src/components/Navbar.jsx" data-component-line="29:12" data-component-id="src/components/Navbar.jsx:29:12"
                >
                  {isOpen ? <X className="h-6 w-6" data-component-path="src/components/Navbar.jsx" data-component-line="33:14" data-component-id="src/components/Navbar.jsx:33:14" /> : <Menu className="h-6 w-6" data-component-path="src/components/Navbar.jsx" data-component-line="33:14" data-component-id="src/components/Navbar.jsx:33:14" />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden" data-component-path="src/components/Navbar.jsx" data-component-line="40:8" data-component-id="src/components/Navbar.jsx:40:8">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-component-path="src/components/Navbar.jsx" data-component-line="41:10" data-component-id="src/components/Navbar.jsx:41:10">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                      isActive(item.href)
                        ? 'text-blue-600 bg-blue-50'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                    }`}
                    onClick={() => setIsOpen(false)}
                    data-component-path="src/components/Navbar.jsx" data-component-line="42:12" data-component-id="src/components/Navbar.jsx:42:12"
                  >
                    {item.name}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  className="block w-full text-center btn-primary mt-4"
                  onClick={() => setIsOpen(false)}
                  data-component-path="src/components/Navbar.jsx" data-component-line="53:12" data-component-id="src/components/Navbar.jsx:53:12"
                >
                  Get Started
                </Link>
              </div>
            </div>
          )}
        </nav>
      )
    }

    export default Navbar